import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export function getBaseChartAccountTemplates(params) {
  return axios.get(`${backendUrl}/baseChartAccountTemplates`, { params });
}

export function getChartAccountsByLevel(params) {
  return axios.get(`${backendUrl}/chartAccount`, { params });
}

export function createChartAccountRequest(payload) {
  return axios.post(`${backendUrl}/chartAccount`, payload);
}

export function updateChartAccountRequest(id, payload) {
  return axios.patch(`${backendUrl}/chartAccount/${id}`, payload);
}

export function getChartAccountsRequest(params) {
  return axios.get(`${backendUrl}/chartAccount`, { params });
}

export function getChartAccountRequest(id) {
  return axios.get(`${backendUrl}/chartAccount/${id}`);
}

export function getFranchiseAccountSettings(franchiseId) {
  return axios.get(`${backendUrl}/franchise-account-settings/franchise/${franchiseId}`);
}

export function createFranchiseAccountSettings(franchiseId, payload) {
  return axios.post(
    `${backendUrl}/franchise-account-settings/franchise/${franchiseId}`,
    payload
  );
}

export function updateFranchiseAccountSetting(settingId, payload) {
  return axios.patch(
    `${backendUrl}/franchise-account-settings/${settingId}`,
    payload
  );
}

export function createBusinessPartnerRequest(payload) {
  return axios.post(`${backendUrl}/businessPartner`, payload);
}

export function updateBusinessPartnerRequest(id, payload) {
  return axios.patch(`${backendUrl}/businessPartner/${id}`, payload);
}

export function getBusinessPartnersRequest(params) {
  return axios.get(`${backendUrl}/businessPartner`, { params });
}

export function getBusinessPartnerRequest(id) {
  return axios.get(`${backendUrl}/businessPartner/${id}`);
}

export function createJournalEntryRequest(payload) {
  return axios.post(`${backendUrl}/journalEntry`, payload);
}

export function updateJournalEntryRequest(id, payload) {
  return axios.patch(`${backendUrl}/journalEntry/${id}`, payload);
}

export function getJournalEntriesRequest(params) {
  return axios.get(`${backendUrl}/journalEntry`, { params });
}

export function getJournalEntryRequest(id) {
  return axios.get(`${backendUrl}/journalEntry/${id}`);
}
